import ContentConfig from '../../config/ContentConfig';
import PlaybackSectionConfig from '../../config/PlaybackSectionConfig';
import logger from '../../log';
import { DeliveryMode, PlayType } from '../constants';
import getPlaybackPriority from './getPlaybackPriority';

const log = logger.getLogger(__filename);

const { ECDN10, ECDN11, WEBRTC } = DeliveryMode;

const modes = (
  type: PlaybackSectionConfig,
  allowed: Set<DeliveryMode>
): DeliveryMode[] => {
  const { priority, blackout } = type || {};
  if (blackout === true) {
    log.warn('Blackout is true for this config: ', type);
    return [];
  } else {
    return getPlaybackPriority(priority).filter(m => allowed.has(m));
  }
};

export default function getModeAttemptOrder(
  config: ContentConfig,
  allowedModes?: DeliveryMode[]
): {
  [PlayType.LIVE]: DeliveryMode[];
  [PlayType.VOD]: DeliveryMode[];
} {
  log.debug('getModeAttemptOrder:', { config, allowedModes });
  const { playback } = config || {};
  const { vod, live } = playback || {};

  const allowedSet = (allowedModes || [ECDN10, ECDN11, WEBRTC]).reduce(
    (acc: Set<DeliveryMode>, next: DeliveryMode) => {
      acc.add(next);
      return acc;
    },
    new Set()
  );

  const liveModes = modes(live, allowedSet);
  const vodModes = modes(vod, allowedSet);

  // if it is allowed and enabled but the browser does not support it, report it as unsupported.
  return {
    [PlayType.LIVE]: liveModes,
    [PlayType.VOD]: vodModes
  };
}
